import React, { useContext, useEffect, useState } from "react";
import { httpService } from "../../httpService";
import { Badge, Table } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { RefreshContext } from "../../App";
import { Link } from "@mui/material";
function ExaminationAttendance() {
  const [registers, setRegisters] = useState([]);

  const { refresh } = useContext(RefreshContext);
  const getRegister = async () => {
    const { data, error } = await httpService(
      "attendance/viewattendanceregister"
    );

    if (data) {
      setRegisters(data);
      console.log(data);
    }
    if (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getRegister();
  }, [refresh]);
  return (
    <div>
      <ToastContainer />
      <div className="mb-3">
        <h3>ATTENDANCE REGISTER</h3>
      </div>
      <div>
        <Table striped borderless>
          <thead>
            <tr>
              <th>S.N</th>
              <th>Examination</th>
              <th>Status</th>
              <th>Action</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {registers.map((c, i) => (
              <>
                {c.examination && (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{c.examination.title}</td>
                    <td>
                      {c.opened ? (
                        <Badge bg="success">opened</Badge>
                      ) : (
                        <Badge bg="danger">closed</Badge>
                      )}
                    </td>
                    <OpenRegister id={c._id} />
                    <td>
                      <Link href={`/attendance/${c._id}`}>view</Link>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default ExaminationAttendance;

function OpenRegister({ id }) {
  const [loading, setLoading] = useState(false);
  const { refresh, setRefresh } = useContext(RefreshContext);
  const openRegister = () => {
    //  toast.success("hello");

    Swal.fire({
      title: "Open Register",
      showCancelButton: true,
      icon: "question",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const { data, error } = await httpService(
          `attendance/registertoggle/${id}`
        );

        if (data) {
          setRefresh(!refresh);
          toast.success(data);
        }
        if (error) {
          toast.error(error);
        }
        setLoading(false);
      }
    });
  };
  return (
    <td>
      <LoadingButton
        sx={{ textTransform: "capitalize" }}
        onClick={openRegister}
        loading={loading}
      >
        toggle
      </LoadingButton>
    </td>
  );
}
